import ReactGA from 'react-ga4'

// Google Analytics Measurement ID
const MEASUREMENT_ID = 'G-JGD961M15C'

// Initialize Google Analytics
export const initializeGA = () => {
  ReactGA.initialize(MEASUREMENT_ID)
}

// Track page view
export const trackPageView = (path: string) => {
  ReactGA.send({ hitType: 'pageview', page: path })
}

// Track custom event
export const trackEvent = (
  category: string,
  action: string,
  label?: string,
  value?: number,
) => {
  ReactGA.event({
    category,
    action,
    label,
    value,
  })
}
